import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

/**
 * 
 * @param {Phaser.GameObjects.GameObject} obj 
 * @param {*} time 
 * @param {*} wait 
 * @param {*} override 
 * @returns 
 */
export function dotPop(obj, time = 320, wait = 0, override = true) {
  if (override) obj.scene.tweens.killTweensOf(obj);

  ABCyaPhaser.Tweens.addTween(obj,240, { delay: wait, scaleX: 1.6, scaleY: 1.6, alpha: 1 }, Phaser.Math.Easing.Quadratic.In);
  return ABCyaPhaser.Tweens.addTween(obj,time, { delay: wait + 240, scaleX: 1, scaleY: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
}